const Config = {
  defaults: {
    namespace: "Application",
    apiUrl: process.env.REACT_APP_API_URL || "/api",
    reCaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || "",
    googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || "",
  },
};

export default Config;
